import _, { isEmpty } from 'lodash';
import { Box } from '@material-ui/core';
import { t, Trans } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import { NgpLabelValue } from '../../form/NgpLabelValue';
import {
    AGENT_REPORTED_NETWORK_ADAPTERS,
    AGENT_VITALS_WIFI_MAC,
    AGENT_WIFI_BSSID_FIELD,
    AGENT_WIFI_CHANNEL_FIELD,
    AGENT_WIFI_CHANNEL_WIDTH_FIELD,
    AGENT_WIFI_CHANNEL_FREQUENCY_FIELD,
    AGENT_WIFI_DEVICE_FIELD,
    AGENT_WIFI_DEVICE_NAME_FIELD,
    AGENT_WIFI_RADIO_NAME_FIELD,
    AGENT_WIFI_SIGNAL_LEVEL_FIELD,
    AGENT_WIFI_SSID_FIELD,
    AGENT_WIFI_TECHNOLOGY_FIELD,
    DBM,
    AGENT_WIFI_AUTUTHENTICATION_FIELD,
    AGENT_WIFI_CIPHER_FIELD,
} from './AgentConstants';
import Link from '../../links/Link';

const ssidLabelText = t`Network`;
const wifiTechnologyLabelText = t`Technology`;
const deviceNameLabelText = t`Wi-Fi Access Point`;
const radioNameLabelText = t`Wi-Fi Radio`;
const wifiBssidLabelText = t`BSSID`;
const wifiIP = t`IP`;
const wifiMacLabelText = t`Wi-Fi MAC`;
const wifiSignalLevelDbmLabelText = t`Signal Strength`;
const wifiChannelLabelText = t`Channel`;
const wifiChannelWidthLabelText = t`Channel Width`;
const wifiChannelFrequencyLabelText = t`Channel Frequency`;
const wifiAuthenticationLabelText = t`Authentication`;
const wifiCipherLabelText = t`Cipher`;

function formatDeviceName(deviceName, agent) {
    if (_.isEmpty(deviceName)) {
        return null;
    }

    const deviceId = _.get(agent, AGENT_WIFI_DEVICE_FIELD);
    if (_.isEmpty(deviceId)) {
        return deviceName;
    }

    const deviceURL = `/admin/monitored-infrastructure/${deviceId}`;
    return <Link to={deviceURL}>{deviceName}</Link>;
}

function getWirelessIP(interfaces) {
    return _.get(_.find(interfaces, { name: 'wlan0' }), 'ipv4');
}

function formatSignalLevel(signalLevel) {
    if (!signalLevel) {
        return null;
    }

    return `${signalLevel} ${DBM}`;
}

function formatChannelWidth(vitalsChannelWidth, agent) {
    if (!vitalsChannelWidth) {
        return null;
    }

    const channelWidth = _.get(agent, AGENT_WIFI_CHANNEL_WIDTH_FIELD);
    return _.isNumber(channelWidth) && channelWidth > 0 ? `${channelWidth} MHz` : 'Unknown';
}

function formatChannelFrequency(channelFrequency) {
    if (!channelFrequency) {
        return null;
    }

    return `${_.round(channelFrequency, 3)}GHz`;
}

export default function AgentReadOnlyWiFi({ agent, readOnlyTopMargin, isWirelessAgent }) {
    if (_.isEmpty(agent)) {
        return null;
    }
    if (isEmpty(_.get(agent, AGENT_VITALS_WIFI_MAC)) && !isWirelessAgent.current) {
        return null;
    }

    return (
        <FormSection title={<Trans>Wi-Fi</Trans>}>
            <Box mt={readOnlyTopMargin}>
                <NgpLabelValue dataLabel={ssidLabelText} dataValue={_.get(agent, AGENT_WIFI_SSID_FIELD)} />
                <NgpLabelValue
                    dataLabel={wifiTechnologyLabelText}
                    dataValue={_.get(agent, AGENT_WIFI_TECHNOLOGY_FIELD)}
                />
                <NgpLabelValue
                    dataLabel={deviceNameLabelText}
                    dataValue={formatDeviceName(_.get(agent, AGENT_WIFI_DEVICE_NAME_FIELD), agent)}
                />
                <NgpLabelValue dataLabel={radioNameLabelText} dataValue={_.get(agent, AGENT_WIFI_RADIO_NAME_FIELD)} />
                <NgpLabelValue dataLabel={wifiBssidLabelText} dataValue={_.get(agent, AGENT_WIFI_BSSID_FIELD)} />
                <NgpLabelValue
                    dataLabel={wifiIP}
                    dataValue={getWirelessIP(_.get(agent, AGENT_REPORTED_NETWORK_ADAPTERS))}
                />
                <NgpLabelValue dataLabel={wifiMacLabelText} dataValue={_.get(agent, AGENT_VITALS_WIFI_MAC)} />
                <NgpLabelValue
                    dataLabel={wifiSignalLevelDbmLabelText}
                    dataValue={formatSignalLevel(_.get(agent, AGENT_WIFI_SIGNAL_LEVEL_FIELD))}
                />
                <NgpLabelValue dataLabel={wifiChannelLabelText} dataValue={_.get(agent, AGENT_WIFI_CHANNEL_FIELD)} />
                <NgpLabelValue
                    dataLabel={wifiChannelWidthLabelText}
                    dataValue={formatChannelWidth(_.get(agent, AGENT_WIFI_CHANNEL_WIDTH_FIELD), agent)}
                />
                <NgpLabelValue
                    dataLabel={wifiChannelFrequencyLabelText}
                    dataValue={formatChannelFrequency(_.get(agent, AGENT_WIFI_CHANNEL_FREQUENCY_FIELD))}
                />
                <NgpLabelValue
                    dataLabel={wifiAuthenticationLabelText}
                    dataValue={_.get(agent, AGENT_WIFI_AUTUTHENTICATION_FIELD)}
                />
                <NgpLabelValue dataLabel={wifiCipherLabelText} dataValue={_.get(agent, AGENT_WIFI_CIPHER_FIELD)} />
            </Box>
        </FormSection>
    );
}
